<template>
  <div style="height: 100%; width: 100%; display: flex; flex-direction: column">

    <!-- <div style="margin-top: 20px" class="cfdian">
      <div style="display: flex; padding-top: 15px">
        <line-chart-outlined style="
            font-size: 24px;
            color: #38f2fe;
            padding-left: 20px;
            padding-right: 15px;
          " />
        <h1 style="color: #fff; font-size: 18px; color: #fdff76">
          近24小时总负载电流
        </h1>
      </div>
      <div class="hoptions">
        <v-chart class="chart" :option="options" :autoresize="true" />
      </div>
    </div> -->
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from "vue";
import * as echarts from "echarts";



export default defineComponent({
  components: {


  },
  props: { info: Object },
  setup() {
    let dataC1 = [20, 30, 60, 40, 50, 30];
    let xData = ["00:00", "04:00", "08:00", "12:00", "16:00", "20:00"];

    const options = ref({
      grid: {
        left: "8%",
        right: "4%",
        top: "10%",
        bottom: "15%",
      },

      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "line",
          lineStyle: {
            color: "#57617B",
          },
        },
      },
      xAxis: {
        type: "category",

        boundaryGap: false, //顶头显示
        axisLine: {
          show: false,
          lineStyle: {
            color: "#fff",
          },
        },
        axisTick: {
          show: false,
          // alignWithLabel: true,
          lineStyle: {
            color: "#3585d5",
          },
        },
        axisLabel: {
          fontSize: 14,
        },
        data: xData,
      },
      yAxis: {
        type: "value",
        axisLine: {
          show: false,
          lineStyle: {
            color: "#fff",
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dotted",
            color: "#3585d5",
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          fontSize: 14,
          formatter: "{value}A",
        },
        boundaryGap: false,
      },
      series: [
        {
          name: "电流",
          type: "line",
          stack: "总量",
          smooth: true,
          symbol: "circle",
          symbolSize: 8,
          itemStyle: {
            normal: {
              color: "#15faff",
              lineStyle: {
                color: "#15faff",
                width: 2,
              },
              areaStyle: {
                //color: '#94C9EC'
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0.4,
                    color: "rgba(21, 250, 255,0.1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(21, 250, 255,0.9)",
                  },
                ]),
              },
            },
          },

          data: dataC1,
        },
      ],
    });

    onMounted(() => {
      //组件挂载时的生命周期执行的方法
    });

    return {
      options,
    };
  },
});
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cfdian {
  border: 1px #2b85e4 solid;
  border-radius: 5px;
  background: rgba(12, 62, 105, 0.5);
  height: calc(100% - 590px);
}

.topbg {
  background: url("@/assets/u64.png") no-repeat bottom center;
}

.hgao {
  /* height: calc(100% - 53px); */
  width: 100%;
}

.shuliang {
  color: #38f2fe;
  font-size: 40px;
  font-family: Arial, Helvetica, sans-serif;
}

.hoptions {
  height: calc(100% - 53px);
}

.ant-col-8 {
  max-width: 100%;
}

.ant-col-6 {
  max-width: 100%;
}
</style>
